// Matomo event tracking (v1 pushed _paq events from game3d.js). No-ops when
// the Matomo snippet isn't present (e.g. staging without the tracker).

import type { EventBus } from '@/app/events';

type Paq = { push: (args: unknown[]) => void };

function paq(): Paq | null {
  const w = window as unknown as { _paq?: Paq };
  return w._paq ?? null;
}

function track(category: string, action: string, name?: string, value?: number): void {
  paq()?.push([
    'trackEvent',
    category,
    action,
    ...(name !== undefined ? [name] : []),
    ...(value !== undefined ? [value] : []),
  ]);
}

export function attachAnalytics(bus: EventBus): void {
  bus.on('run:started', ({ districtId }) => track('Game', 'RunStarted', districtId));
  bus.on('run:ended', ({ score, distance }) => {
    track('Game', 'RunEnded', 'score', score);
    track('Game', 'RunEnded', 'distance', Math.floor(distance));
  });
  bus.on('belt:promoted', ({ name }) => track('Game', 'BeltPromoted', name));
  bus.on('combat:ended', ({ victory }) => track('Game', victory ? 'CombatWon' : 'CombatLost'));
  bus.on('powerup:activated', ({ typeId }) => track('Game', 'PowerUp', typeId));
}
